import React from 'react';
import DeliveryComponent from '../components/Delivery';
import './Delivery.css';

function Delivery() {
  return (
    <div className="delivery-page">
      <DeliveryComponent />
    </div>
  );
}

export default Delivery;

